/**
 * KULLANICI TÜRÜNE GÖRE ANA SAYFA.
 *
 * NEDEN AYRI DOSYA: `guards.tsx` bileşen dosyasıdır ve yanına bileşen
 * olmayan bir dışa aktarım koymak Vite'ın hızlı yenileme (Fast Refresh)
 * sınırını bozar — o dosyadaki her düzenleme, bileşen state'ini koruyarak
 * yenilemek yerine modülü baştan yükler. Geliştirme sırasında bu, açık
 * bir formun her kayıtta sıfırlanması demektir.
 *
 * Kural tek yerde durur; hem giriş ekranı hem her iki route ağacı bunu okur.
 */
export function homePathFor(userType: 'STAFF' | 'TENANT'): string {
  return userType === 'TENANT' ? '/portal' : '/dashboard';
}
